export function data() {
  return {
    input: '2022-01-21T05:00:00.000Z',
    point: '2022-01-21T05:00:00.000'
  }
}
